import api from '../api';

export const transactionsGraph = async workspaceId => {
  return api
    .get(`/v0/user/${workspaceId}/transactions/stats`)
    .then(response => response.data);
};

export const getTransactions = async (env, workspaceId) => {
  return api
    .get(`/v0/user/${workspaceId}/transactions?environment=${env}`)
    .then(response => response.data);
};

export const getTransactionsById = async id => {
  return api.get(`/v0/user/transactions/${id}`).then(response => response.data);
};
